import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLPIERCING', label: 'Piercing Line', lookback: 11 })
